export default "__VITE_ASSET__Bgs4ku4c__"